<template>
  <el-dialog title="导出" v-if="visible" :visible.sync="visible" width="30%" :append-to-body="true">
    <h3>确认导出所有数据？</h3>
    <el-radio-group v-model="radio">
      <el-radio label="2">汇总</el-radio>
      <el-radio label="1">明细</el-radio>
    </el-radio-group>
    <div class="btn">
      <el-button type="primary" :loading="isExporting" @click="doExport">确定</el-button>
      <el-button @click="doCancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getTreeExcel } from '@/api/v4ward/paylist/feepaylist';
import { export_json_to_excel } from '@/vendor/Export2Excel';

export default {
  props: {
    query: {},
    allPayTypeList: [],
    allPayCostList: [],
    visible: false,
  },
  data() {
    return {
      radio: '2',
      isExporting: false,
      excelSumInfo: {
        labels: [
          '地址',
          '缴费人',
          '费项',
          '收费时间',
          '应收金额',
          '滞纳金',
          '减免金额',
          '账户抵扣金额',
          '优惠券抵扣金额',
          '收费金额',
          '支付方式',
          '收款人',
          '票据号',
          '收费摘要',
          '缴费来源',
        ],
        keys: [
          'roomName',
          'householdName',
          'feeSortCount',
          'payTime',
          'shouldAmount',
          'delayAmount',
          'derateAmount',
          'accountpayAmount',
          'couponAmount',
          'payAmount',
          'payType',
          'cashierName',
          'invoiceNo',
          'payRemark',
          'payCost',
        ],
      },
      excelDetailInfo: {
        labels: [
          '地址',
          '费项类别',
          '收费周期',
          '缴费人',
          '收费时间',
          '应收金额',
          '滞纳金',
          '抵扣金额',
          '优惠金额',
          '收费金额',
          '支付方式',
          '收款人',
          '票据号',
        ],
        keys: [
          'roomName',
          'feeSortName',
          'billcycleNo',
          'householdName',
          'payTime',
          'shouldAmount',
          'delayAmount',
          'accountpayAmount',
          'derateAmount',
          'payAmount',
          'payType',
          'cashierName',
          'invoiceNo',
        ],
      },
    };
  },
  watch: {
    visible() {
      this.$emit('update:visible', this.visible);
    },
  },
  methods: {
    doCancel() {
      this.visible = false;
    },
    doExport() {
      this.isExporting = true;
      getTreeExcel(Object.assign({}, this.query))
        .then(({ data }) => {
          if (data.length == 0) {
            this.$message.error('暂无有效数据');
            return;
          }
          // 导出excel 的标题
          const tHeader = this.radio == 2 ? this.excelSumInfo.labels : this.excelDetailInfo.labels;
          // 每个标题对应的字段
          const filterVal = this.radio == 2 ? this.excelSumInfo.keys : this.excelDetailInfo.keys;

          const list = (data || []).map((item) => {
            let obj = {};
            filterVal.forEach((key) => {
              if (key == 'payTime') {
                obj[key] = this.dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss');
              } else if (key == 'payType') {
                obj[key] = this.payTypeToPayTypeName(item.payType)
              } else if (key == 'payCost') {
                obj[key] = this.payCostToName(item.payCost);
              } else {
                obj[key] = item[key];
              }
            });
            return obj;
          });
          const jsonData = this.formatJson(filterVal, list); // 生成json数据

          export_json_to_excel({
            // 调用excel方法生成表格
            header: tHeader,
            data: jsonData,
            filename: '收费明细' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
          });
          this.visible = false;
        })
        .catch((error) => {
          this.isExporting = false;
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
    payCostToName(payCost) {
      var payCostName = '';
      this.allPayCostList.forEach(function (value, index, array) {
        if (value.dictKey == payCost) {
          payCostName = value.dictValue;
          return;
        }
      });
      return payCostName;
    },
  },
};
</script>

<style scoped>
.btn {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
